<app-mobility-manager-payment-account-form
  [paymentAccount]="data.organizationPaymentAccount.paymentAccount"
  [isEditMode]="data.isEditMode"
  [submittingPaymentAccount]="(isSubmitting$ | async) ?? false"
  (cancel)="dialogRef.close()"
  (create)="handleCreatePaymentAccount($event)"
  (update)="handleUpdatePaymentAccount($event)">
</app-mobility-manager-payment-account-form>
